import { render, staticRenderFns } from "./ApplianceList.vue?vue&type=template&id=5d6428e0"
import script from "./ApplianceList.vue?vue&type=script&lang=js"
export * from "./ApplianceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports